import { ChangeEvent, FC, useState } from "react"
import s from "./UpdateStoks.module.css"
import { useAppDispatch } from "../../app/hooks"
import { Modal } from "../../features/Modal/Modal"
import {
  deleteCurrentDataKatrenForWB,
  deletePromoDataWB,
  katrenUpdateStoksForWB,
  savePromoDataWB,
  uploadCurrentDataKatrenForWB,
} from "../../app/reducers/updateStoksKatren"
import { Tip, TipType } from "../Tip/Tip"
import { STATUS } from "../../utils/const"
import { StatusInfo } from "../UpdateStoksIcon/StatusInfo/StatusInfo"
import { getWbkatrnLogData, preparePromoXlsx, preparePromoZip } from "./helpers"
import { DownloadRecodeWbBtn } from "./downloadRecode/DownloadRecodeWbBtn"
import { LogButton } from "../LogButton/LogButton"
import { NotificationService } from "../../features/NotificationService/NotificationService"
import { StorageSelectControl } from "../StorageSelect/StorageSelectControl"
import { MARKETPLACE } from "@acc/shared"
import { getMessage } from "../../msgs/msgs"
import { ObjectRenderer } from "../ObjectViewer/ObjectViewer"
import { StocksTable } from "../ObjectViewer/ObjectTableViewer"
import { Checkbox, Button } from "@radix-ui/themes"

type WildberriesTabProps = {
  lastStoksUpdated: string
  lastPricesUpdated: string
  status?: STATUS
  isCurrentDataUploaded: boolean
  isDataFromKatrenUploaded: boolean
  isPromotionDataUploaded: boolean
  storages: {
    name: string
    officeId: number
    id: number
  }[]
  errors?: { type: string; errors: any[] }[]
}

export const WildberriesTab: FC<WildberriesTabProps> = ({
  lastStoksUpdated,
  lastPricesUpdated,
  isCurrentDataUploaded,
  isDataFromKatrenUploaded,
  status,
  storages,
  isPromotionDataUploaded,
  errors,
}) => {
  const dispatch = useAppDispatch()
  const [selectedStorageId, setSelectedStorages] = useState("")
  const [isOpenModalUpdatePrices, setOpenModalUpdatePrices] = useState(false)
  const [isOpenErrModal, setOpenErrModal] = useState(false)
  const [updatePrices, setUpdatePrices] = useState(false)
  const [updateStocks, setUpdateStocks] = useState(false)
  const [isReturnToPromo, setReturnToPromo] = useState(false)
  const handleUpdate = () => {
    if (
      (updatePrices || updateStocks || isReturnToPromo) &&
      isCurrentDataUploaded &&
      isDataFromKatrenUploaded &&
      selectedStorageId &&
      (isReturnToPromo ? isPromotionDataUploaded : true)
    ) {
      setOpenModalUpdatePrices(true)
    }
  }

  return (
    <div>
      <div className="flex gap-20  flex-justify-center">
        <div className={`${s.uploadFileWrap} flex-column-reverse`}>
          {isCurrentDataUploaded ? (
            <div className={s.uploadedWrap}>
              <Button
                onClick={() => {
                  dispatch(deleteCurrentDataKatrenForWB())
                }}
              >
                Удалить файл перекодировки
              </Button>
              <DownloadRecodeWbBtn />
            </div>
          ) : (
            <div>
              <Button asChild>
                <label htmlFor={s.ktrnFileInp}>
                  Загрузить файл перекодировки
                  <input
                    style={{ display: "none" }}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      const file = e.target.files?.[0]
                      if (file) {
                        dispatch(uploadCurrentDataKatrenForWB(file))
                      }
                    }}
                    type="file"
                    accept=".xlsx"
                    id={s.ktrnFileInp}
                  />
                </label>
              </Button>
            </div>
          )}
          <Tip
            content={
              <span>
                <b>Внимание! Файл перекодировки</b>
                <p>
                  Файл должен быть формата <b>XLSX</b> и содержать следующие{" "}
                  <b>обязательные</b> колонки:
                </p>
                <ol className={s.list}>
                  <li>
                    <b>GoodName</b> - название продукта c катрена
                  </li>
                  <li>
                    <b>GoodCode</b> - артикул продавца с WB
                  </li>
                  <li>
                    <b>nmId</b> - артикул WB
                  </li>
                  <li>
                    <b>sku</b> - баркод с WB
                  </li>
                  <li>
                    <b>count</b> - количество товаров продоваемых в карточке
                    (кратность)
                  </li>
                  <li>
                    <b>commission</b> - комиссия. Если не заполнено, то будет
                    использовано значение из параметра цен
                  </li>
                </ol>
              </span>
            }
            type={TipType.WARNING}
          />
        </div>
        <div className={`${s.uploadFileWrap} flex-column-reverse`}>
          {isPromotionDataUploaded ? (
            <div className={s.uploadedWrap}>
              <Button
                onClick={() => {
                  dispatch(deletePromoDataWB())
                }}
              >
                Удалить файл цен для акций
              </Button>
            </div>
          ) : (
            <div>
              <Button asChild>
                <label htmlFor={s.ktrnPromoFileInp}>
                  Загрузить файл цен для акций
                  <input
                    style={{ display: "none" }}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      const file = e.target.files?.[0]
                      if (file) {
                        const isZip = e.target.files?.[0].name.endsWith(".zip")
                        const isXlsx =
                          e.target.files?.[0].name.endsWith(".xlsx")
                        const func = isZip
                          ? preparePromoZip(file)
                          : (isXlsx && preparePromoXlsx([file])) ||
                            Promise.resolve([])
                        func.then((data) => {
                          if (data?.length) {
                            NotificationService.showNotification({
                              message: `Обработано ${data.length} артикулов`,
                              level: "info",
                            })
                            dispatch(savePromoDataWB(data))
                          } else {
                            NotificationService.showNotification({
                              message: `Пустой файл или ошибка при обработке файла `,
                              level: "error",
                            })
                          }
                        })
                      }
                    }}
                    type="file"
                    accept=".zip, .xlsx"
                    id={s.ktrnPromoFileInp}
                  />
                </label>
              </Button>
            </div>
          )}
          <Tip
            content={
              <span>
                <b>Внимание! Файл цен для акций</b>
                <p>
                  Файл должен быть формата <b>XLSX или ZIP</b> и содержать
                  следующие <b>обязательные</b> колонки:
                </p>
                <ol className={s.list}>
                  <li>
                    <b>nmId</b> - Артикул WB
                  </li>
                  <li>
                    <b>planPrice</b> - Плановая цена для акции
                  </li>
                </ol>
              </span>
            }
            type={TipType.WARNING}
          />
        </div>
      </div>
      {lastPricesUpdated && (
        <h6>
          Последнее обновление цен:{" "}
          {new Date(lastPricesUpdated).toLocaleString()}
        </h6>
      )}
      {lastStoksUpdated && (
        <h6>
          Последнее обновление остатков:{" "}
          {new Date(lastStoksUpdated).toLocaleString()}
        </h6>
      )}
      <div className="flex flex-column flex-align-center flex-justify-center">
        {status && (
          <h6>
            статус: <StatusInfo status={status} />
          </h6>
        )}
        {(errors?.length && (
          <div className="flex gap-20">
            <StatusInfo
              status={STATUS.WARN}
              value="При обновлении были пропущены ошибки"
            />
            <Button onClick={() => setOpenErrModal(true)} color="red">
              посмотреть ошибки
            </Button>
          </div>
        )) ||
          null}
      </div>
      <StorageSelectControl
        label="Склад для обновления"
        value={selectedStorageId}
        onChange={(value) => {
          setSelectedStorages(value)
        }}
        controlKey="storages-select"
        marketplace={MARKETPLACE.WB}
      />
      <div className={s.checkboxContainer}>
        <label>
          <Checkbox
            checked={updatePrices}
            onCheckedChange={(value) => setUpdatePrices(value === true)}
          />
          Обновить цены
        </label>
        <label>
          <Checkbox
            checked={updateStocks}
            onCheckedChange={(value) => setUpdateStocks(value === true)}
          />
          Обновить остатки
        </label>
        <label>
          <Checkbox
            checked={isReturnToPromo}
            onCheckedChange={(value) => setReturnToPromo(value === true)}
          />
          Вернуть в акцию
        </label>
      </div>
      <div>
        <Button
          className={s.updateButton}
          disabled={
            !isCurrentDataUploaded ||
            !isDataFromKatrenUploaded ||
            !selectedStorageId ||
            (!updatePrices && !updateStocks && !isReturnToPromo) ||
            (isReturnToPromo && !isPromotionDataUploaded)
          }
          onClick={handleUpdate}
        >
          Обновить wildberries
        </Button>
        <LogButton getData={getWbkatrnLogData} />
      </div>

      <Modal
        isOpen={isOpenModalUpdatePrices}
        header="Подтвердите действие. Обновление на WILDBERRIES"
        content={`Обновить ${updatePrices ? "цены" : ""} ${
          updatePrices && updateStocks ? "и" : ""
        } ${updateStocks ? "остатки" : ""} для склада ${
          storages.find((el) => +el.id === +selectedStorageId)?.name
        }`}
        onClose={() => setOpenModalUpdatePrices(false)}
        onOk={() => {
          selectedStorageId &&
            dispatch(
              katrenUpdateStoksForWB({
                selectedStorageId,
                updatePrices,
                updateStocks,
                isReturnToPromo,
              }),
            )
          setOpenModalUpdatePrices(false)
        }}
      />

      <Modal
        isOpen={isOpenErrModal}
        header="Ошибки пропущенные при обновлении"
        onClose={() => setOpenErrModal(false)}
        onOk={() => setOpenErrModal(false)}
        size="auto"
        content={
          <div className="flex flex-column gap-20">
            {errors?.map((el) => {
              if (el.type === "UPLOAD_STOCKS") {
                return <StocksTable data={el} />
              }
              return (
                <div className="flex gap-20">
                  <b>{getMessage(el.type)}</b>
                  <ObjectRenderer data={el.errors} />
                </div>
              )
            })}
          </div>
        }
      ></Modal>
    </div>
  )
}
